import apiClient from "lib/axios";
import type { Dossier, DossierStep } from "types/dossier.types";

export const dossierService = {
  /** Liste tous les dossiers de l'étudiant connecté */
  list: async (): Promise<Dossier[]> => {
    const { data } = await apiClient.get<Dossier[]>("/student/dossiers");
    return data;
  },

  /** Détail d'un dossier avec étapes et documents */
  get: async (id: number): Promise<Dossier> => {
    const { data } = await apiClient.get<Dossier>(`/student/dossiers/${id}`);
    return data;
  },

  /** Créer un dossier pour une destination */
  create: async (destinationId: number): Promise<Dossier> => {
    const { data } = await apiClient.post<Dossier>("/student/dossiers", {
      destinationId,
    });
    return data;
  },

  /** Passer le dossier en actif */
  activate: async (id: number): Promise<Dossier> => {
    const { data } = await apiClient.patch<Dossier>(
      `/student/dossiers/${id}/activate`,
    );
    return data;
  },

  /** Étapes du dossier */
  getSteps: async (id: number): Promise<DossierStep[]> => {
    const { data } = await apiClient.get<DossierStep[]>(
      `/student/dossiers/${id}/steps`,
    );
    return data;
  },

  /** Marquer une étape "en cours" */
  startStep: async (
    dossierId: number,
    stepId: number,
  ): Promise<DossierStep> => {
    const { data } = await apiClient.patch<DossierStep>(
      `/student/dossiers/${dossierId}/steps/${stepId}`,
      { status: "in_progress" },
    );
    return data;
  },
};
